import {
    Box,
    Button,
    Stack,
    TextField,
    IconButton,
    CircularProgress,
} from "@mui/material";

import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";

import { useNavigate } from "react-router-dom";
import { useState } from "react";
import PropTypes from "prop-types";

import { HEADER_HEIGHT } from "../constants/layout";

import {
    runParseJob,
    runSplitJob,
    runTranscribeJob,
} from "../api/jobRoutes";

import { JOB_STATUS } from "../constants/status";

import {
    JOB_TYPE,
    RUN_BUTTON_LABEL,
} from "../constants/constants";

export default function EditorTopbar({
                                         job,
                                         fetchJob,
                                     }) {
    const navigate = useNavigate();

    const [runLoading, setRunLoading] =
        useState(false);

    const handleRunJob = async () => {
        try {
            setRunLoading(true);

            let response;

            if (job.type === JOB_TYPE.PARSE) {
                response = await runParseJob(
                    job.id,
                    job.file.id
                );
            } else if (
                job.type === JOB_TYPE.SPLIT
            ) {
                response = await runSplitJob(
                    job.id,
                    job.file.id
                );
            } else if (
                job.type === JOB_TYPE.TRANSCRIBE
            ) {
                response = await runTranscribeJob(
                    job.id,
                    job.file.id
                );
            }

            console.log(response);

            await fetchJob();
        } catch (error) {
            console.error(error);
        } finally {
            setRunLoading(false);
        }
    };

    return (
        <Box
            sx={{
                height: HEADER_HEIGHT,
                px: 3,
                borderBottom:
                    "1px solid #e5e7eb",

                display: "flex",
                alignItems: "center",
                justifyContent:
                    "space-between",

                background:
                    "rgba(255,255,255,.9)",

                backdropFilter:
                    "blur(12px)",
            }}
        >
            {/* LEFT SIDE */}
            <Stack
                direction="row"
                spacing={1}
                sx={{
                    alignItems: "center",
                }}
            >
                <IconButton
                    onClick={() =>
                        navigate(-1)
                    }
                    sx={{
                        width: 36,
                        height: 36,
                        borderRadius: 2,
                        color: "#374151",

                        "&:hover": {
                            backgroundColor:
                                "#f3f4f6",
                        },
                    }}
                >
                    <ArrowBackRoundedIcon fontSize="small" />
                </IconButton>

                <TextField
                    variant="standard"
                    defaultValue={
                        job?.name ||
                        "Untitled"
                    }
                    slotProps={{
                        input: {
                            disableUnderline: true,
                        },
                    }}
                    sx={{
                        "& .MuiInputBase-input":
                            {
                                fontSize: 15,
                                fontWeight: 500,
                                color: "#111827",
                            },
                    }}
                />
            </Stack>

            {/* RIGHT SIDE */}
            <Stack
                direction="row"
                spacing={1.5}
                sx={{
                    alignItems: "center",
                }}
            >
                <Button
                    startIcon={
                        runLoading ? (
                            <CircularProgress
                                size={18}
                                color="inherit"
                            />
                        ) : (
                            <AutoFixHighIcon />
                        )
                    }
                    variant="contained"
                    disabled={
                        job?.status !==
                        JOB_STATUS.FILE_UPLOADED ||
                        runLoading
                    }
                    onClick={handleRunJob}
                    sx={{
                        textTransform:
                            "none",

                        borderRadius: 3,

                        px: 3,

                        boxShadow: 0,

                        background:
                            "linear-gradient(135deg,#7c3aed 0%, #a855f7 100%)",

                        "&.Mui-disabled":
                            {
                                background:
                                    "#e5e7eb",

                                color:
                                    "#9ca3af",
                            },
                    }}
                >
                    {runLoading
                        ? RUN_BUTTON_LABEL.PROCESSING
                        : RUN_BUTTON_LABEL.IDLE}
                </Button>
            </Stack>
        </Box>
    );
}

EditorTopbar.propTypes = {
    job: PropTypes.object.isRequired,
    fetchJob: PropTypes.func.isRequired,
};